import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    const input = this.inputTarget
    input.placeholder = "(###) ###-####"
    input.addEventListener("input", this.handleInput.bind(this))
    // Initial format
    this.handleInput({ target: input })
  }

  handleInput(event) {
    const input = event.target
    const value = input.value
    const cursorPos = input.selectionStart
    const { formatted, newCursor } = this.applyMask(value, cursorPos)
    input.value = formatted
    this.validate()
    setTimeout(() => { input.setSelectionRange(newCursor, newCursor) }, 0)
  }

  validate() {
    const input = this.inputTarget
    const digits = input.value.replace(/\D/g, "")

    if (digits.length === 10) {
      input.setCustomValidity("")
    } else {
      input.setCustomValidity("Please enter a complete 10-digit phone number.")
    }
  }

  applyMask(value, cursorPos) {
    const mask = ["(", "d", "d", "d", ")", " ", "d", "d", "d", "-", "d", "d", "d", "d"]
    let result = ""
    let maskIndex = 0
    let inputIndex = 0
    let newCursorPos = 0
    const isDigit = (ch) => /\d/.test(ch)

    while (inputIndex < value.length && maskIndex < mask.length) {
      const char = value[inputIndex]
      const expected = mask[maskIndex]
      let advanceInput = true

      if (expected === "d") {
        if (isDigit(char)) {
          result += char
          maskIndex++
        }
        // else skip non-digit
      } else {
        if (char === expected) {
          result += char
          maskIndex++
        } else if (isDigit(char)) {
          result += expected
          maskIndex++
          advanceInput = false
        }
        // else skip invalid non-digit
      }

      if (advanceInput) {
        inputIndex++
        if (inputIndex === cursorPos) {
          newCursorPos = result.length
        }
      }
    }

    if (cursorPos > inputIndex) {
      newCursorPos = result.length
    }

    return { formatted: result, newCursor: newCursorPos }
  }
}
